import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectCurrentUser } from '@app/core/user/state/user-data.selectors';
import { IZDBUser } from '@app/core/user/user.model';
import { selectUserId } from '@medrecord/managers-auth';

@Component({
  selector: 'zdb-patient-edit',
  templateUrl: './patient-edit.component.html',
  styleUrls: ['./patient-edit.component.scss']
})
export class PatientEditComponent implements OnInit {

  userId$: Observable<string>;
  user$: Observable<IZDBUser>;
  constructor(private store: Store) {}

  ngOnInit(): void {
    // FIXME: retrieve the patient, not the currently logged in user
    this.userId$ = this.store.select(selectUserId);
    this.user$ = this.store.select(selectCurrentUser);
  }

}
